<template>
    <v-card elevation="2" :loading="loading" class="widget dddark">
        <WidgetHeader
            v-if="title"
            :title="title"
            :info="info"
            :important="important"
            :upselling="upselling"
            :bigHeader="bigHeader"/>

        <div v-if="reportMode" class="text-center text--darken-2 mb-2 pa-2 text-body-2" :class="upselling ? 'orange--text':'ddgrey--text'">
            {{info}}
        </div>

        <div class="widget-content">
            <slot></slot>
        </div>
    </v-card>
</template>

<script>
import WidgetHeader from '@/components/dashboard/WidgetHeader';

/**
 * Widget its a simple wrapper of the visual box that includes any visualization
 * of the dashboard. The content of the widget must be provided as inner single
 * element inside the Widget declaration. Ex.:
 *      <Widget ...>
 *          <MyVisualization />
 *      </Widget>
 */
export default {
    name: 'Widget',
    props: {
        title: {
            type: String,
            required: false,
            default: null
        },
        info: {
            type: String,
            default: null
        },
        important: {
            type: Boolean,
            default: false
        },
       upselling: {
            type: Boolean,
            default: false
        },
        bigHeader: {
            type: Boolean,
            defaul: false
        },
        loading: {
            type: Boolean,
            defaul: false
        },
        reportMode: {
            type: String,
            defaul: false
        },

    },
    computed: {
        isReport() { return this.reportMode !== null }
    },
    components: { WidgetHeader }
}
</script>

<style scoped>
.widget {
    display: flex;
    flex-direction: column;
    height: 100%;
    min-height: 200px;
}

.widget-content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    flex-grow: 1;
    padding: 16px 8px;
}
</style>